export default class FeeCalculator {
  static calculate(config, formValues) {

    if (!config?.multiConditionalAmt) return [];
    const { fieldMapWithAmount, fieldType, multiCheckAmount } = config.multiConditionalAmt;

     console.log('inside the condition',fieldMapWithAmount, fieldType, multiCheckAmount)
    // Get the field value from state (array for MULTI_CHECKBOX, string otherwise)
    const fieldValue = formValues[fieldMapWithAmount];
    if (!fieldValue) return [];

    for (const conditionObj of multiCheckAmount) {
      const { conditions, fees } = conditionObj;

      // Case 1: No conditions -> directly return fees
      if (!conditions) {
         console.log('inside the No condition')
        return FeeCalculator.filterFees(fees, fieldValue, fieldType);
      }

      // Case 2: Conditions present
      if (FeeCalculator.evaluateCondition(conditions, formValues)) {
        console.log('inside the condition present',conditions, formValues)
        return FeeCalculator.filterFees(fees, fieldValue, fieldType);
      }
    }

    return [];
  }

  static evaluateCondition(conditions, formValues) {
     console.log('inside the condition evaluate',formValues)
    const { operator, rules } = conditions;
     console.log('rule and operation', rules,operator);
    if (!rules || rules.length === 0) return false;

    if (operator === "OR") {
      return rules.some(rule => formValues[rule.fieldId] === rule.fieldValue);
    }

    if (operator === "AND") {
      return rules.every(rule => formValues[rule.fieldId] === rule.fieldValue);
    }

    return false;
  }

  static filterFees(fees, fieldValue, fieldType) {

    console.log("inside the filter fees",fees, fieldValue, fieldType);
    if (fieldType === "MULTI_CHECKBOX" && Array.isArray(fieldValue)) {
         console.log("inside the filter cond", fees.filter(f => fieldValue.includes(f.feildValue)));
      return fees.filter(f => fieldValue.includes(f.fieldValue));
    }
    return fees.filter(f => f.fieldValue === fieldValue);
  }

  static totalAmount(config, formValues) {
    console.log('Inside the tAmount', config,formValues);
    const fees = FeeCalculator.calculate(config, formValues);
     const total =  fees.reduce((sum, f) => sum + f.amount, 0);
     return total.toString();
  }
}
